<template>
      <template v-if="mode === 'table'"> 
        <div v-if= "JSON.stringify(valuedetails.rows)!= '[{}]' && JSON.stringify(valuedetails.rows)!= '[]'">
          <div v-if="valuedetails.rows.length > 0">
            <v-btn 
            variant="tonal" 
            @click="detailsoverlay = !detailsoverlay"
            >
            {{ valuedetails.rows.length }} <svg-icon type="mdi" :path="mdiChevronDown"/>
            </v-btn>
          </div>
        </div>
        <div v-else>
            <div></div>
        </div>
        <v-overlay
          v-model="detailsoverlay"
          class="align-center justify-center"
          scroll-strategy="block"
          max-width="1200"
        >
        <v-card>
       
        <v-card-text class="bg-white text-h5">

      <v-table>
      <thead>
        <tr>
          <th v-for="col in metadetails.columns" v-bind:key="col"> {{col.title}} </th>
        </tr> 
      </thead>
      <tbody>
        <tr v-for="row in valuedetails.rows"  :key="row.id">
          <td v-for="col in metadetails.columns" v-bind:key="col">
    <base-geo-cell v-bind="{mode:'table',column:col, initValue:row[col.fieldname], meta:metadetails, rowobject:row}"/>
          </td>
        </tr>
      </tbody>
    </v-table>
        </v-card-text> 
        <div class="px-2">
              <v-card-actions>
                <v-row justify="space-between" class="text-center">
                  <v-col><v-btn
                    class="my-1"
                    variant="flat" 
                    color="regular" 
                    block @click="detailsoverlay = false"
                  >Close</v-btn></v-col>
                </v-row>
              </v-card-actions>
      </div>

        </v-card>
        </v-overlay>
      </template>


      <template v-else-if="mode === 'view'">
        <v-table>
          <thead>
            <tr>
              <th v-for="col in metadetails.columns" v-bind:key="col"> {{col.title}} </th>
            </tr> 
          </thead>
          <data-table :meta="metadetails" v-model = "valuedetails.rows" @getrow = "setcurentRowDet"> </data-table>
        </v-table>

      </template>

      <template v-else-if="mode === 'labelprint'">
        <div v-if="modelValue">
          <div v-for="row in modelValue.rows.slice(1)" :key="row"> 
            <div v-if="row.species">
              {{ row.species.name }}
            </div>          
          </div>  
        </div>
      </template>


    <template v-else-if="mode === 'edit'">
      <v-card class="pa-1" variant="outlined" color="regular"> {{ metadetails.title }}
        <v-sheet class="my-1">
          <div v-if="modelValue">
            <v-table>
              <thead>
                <tr>
                  <th v-for="col in metadetails.columns" v-bind:key="col"> {{col.title}} </th>
                </tr> 
              </thead>
              <data-table :meta="metadetails" v-model = "modelValue.rows" @getrow = "setcurentRowDet"> </data-table>
            </v-table>
          </div>
          <div v-else>
            <div></div>
          </div>
        </v-sheet>


        <v-btn class="mr-2" @click="dialogedrowdetails=!dialogedrowdetails, initDetailsRow('add'), actionadd = !actionadd">Add</v-btn>
        <v-btn class="mr-2" v-if="editButton==true" @click="dialogedrowdetails=!dialogedrowdetails, actionedit = !actionedit ">Edit</v-btn>
        <v-btn class="mr-2" v-if="editButton==true" @click="dialogedrowdetails=!dialogedrowdetails, initDetailsRow('clone'), actionclone =!actionclone">Clone</v-btn>
        <v-btn class="mr-2" v-if="editButton==true" @click="updateDetailsData('delete')">Delete</v-btn>

        <v-btn v-if="editButton==true" @click="updateDetailsData('move')">Move to First</v-btn>
      </v-card>
      <v-dialog v-model="dialogedrowdetails" fullscreen max-width="600">
        <v-card class="rounded-0 px-1">
          <v-card-text>
            <v-sheet>
              <v-sheet v-for="col in metadetails.columns" :key="col">
                <base-geo-cell v-bind="{mode:'edit', column:col, meta:metadetails, rowobject:curentRowDet}" v-model="curentRowDet[col.fieldname]"/>
              </v-sheet>
            </v-sheet>

            <div class="d-flex justify-space-between">
              <v-btn v-if="actionedit" class="my-1" @click="dialogedrowdetails = !dialogedrowdetails, updateDetailsData('delete'), actionedit = false, actionclone = false, actionadd = false">Delete</v-btn>
              <v-btn class="my-1" variant="outlined" color="regular" @click="dialogedrowdetails = !dialogedrowdetails, actionedit = false, actionclone = false, actionadd = false">Exit</v-btn>
              <v-btn v-if="actionedit" class="my-1" variant="flat" color="regular" @click="dialogedrowdetails = !dialogedrowdetails,  updateDetailsData(), actionedit = false, actionclone = false, actionadd = false">Save</v-btn>
              <v-btn v-if="actionadd" class="my-1" @click="dialogedrowdetails=!dialogedrowdetails, addRowDetails(), actionedit = false, actionclone = false, actionadd = false">Save</v-btn>
              <v-btn v-if="actionclone" class="my-1" @click="dialogedrowdetails=!dialogedrowdetails, addRowDetails(), actionedit = false, actionclone = false, actionadd = false">Save</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>

    </template>
    <template v-else>
        {{valuedetails}}
    </template> 

</template>

<script>
import BaseTableTools from '@/components/BaseTableTools.vue';
import DataTable from '@/components/DataTable.vue';
import SvgIcon from '@jamescoyle/vue-icon';
import { mdiChevronDown } from '@mdi/js';

import {arrayMoveImmutable} from 'array-move';

export default {
  name: 'DetailsWidget',
  props:['mode','column','meta','modelValue'],
  emits: ['update:modelValue'],
    data(){ 
      return {
        valuedetails: {"rows":[{}],"det":{ "sort":[]}},
        mdiChevronDown:mdiChevronDown,
        metadetails: {},
        dialogVisible: false,
        detailsoverlay: false, // value of modal window
        dialogedrowdetails: false,
        curentRowDet: {},
        editButton: false,
        actionedit: false,
        actionclone: false,
        actionadd: false,
        selectedIndex: null,
        premoved: {},
      }
    },
  components: {
    BaseTableTools,
    DataTable,
    SvgIcon,
    arrayMoveImmutable,
  },

  mounted(){
    this.getMetaAndUpdate();
  },

  methods: {

    getMetaAndUpdate() {
      this.metadetails = this.column.widget.properties.detailmeta;
      this.metadetails.columns=this.metadetails.columns.filter(col=> {return col.visible});
      if (this.modelValue !== '') {
        this.valuedetails=this.sortRows(this.metadetails.columns, this.modelValue);
      }
    },

    sortRows(columns, value){ //sorting to output
      if(value && value.det && value.det.sort && value.det.sort.length>0){
        let list=[];
        let hashlist=this.valuedetails.det.sort;
          for(let j=0; j<value.rows.length; j++){
            hashlist.push(this.gethash(columns, value.rows[j]));
          }
          for(let i=0; i<value.det.sort.length; i++){
            for(let j=0; j<value.rows.length; j++){
              if(hashlist[j] == value.det.sort[i] || value.rows[j].id == value.det.sort[i]){
                list.push(value.rows[j]);
                value.rows[j].rowadded=true;
                break;
              }
            }
          }
          for(let j=0; j<value.rows.length; j++){
            if(!value.rows[j].rowadded){
              list.push(value.rows[j]);
            }
          }
        value.rows=list;
      }
// if old records doesn't have det.sort:
      else if (value && !value.det) {
        value.det = { "sort":[]};
        let list=[];
        let hashlist=[];
          for(let j=0; j<value.rows.length; j++){
          hashlist.push(this.gethash(columns, value.rows[j]));
        }
//        this.valuedetails = {"rows": hashlist,"det":{ "sort":[]}};
        for(let i=0; i<hashlist.length; i++){
              list.push(value.rows[i]);
              value.rows[i].rowadded=true;
              break;
        }
        for(let j=0; j<value.rows.length; j++){
          if(!value.rows[j].rowadded){
            list.push(value.rows[j]);
          }
        }
        value.rows=list;
//        console.log(value, value.rows, value.det);
      }

      return value;
    },

    setcurentRowDet(getrow, index) {
      this.curentRowDet = getrow;
      this.editButton = true;
      this.selectedIndex = index;
    },
        
    updateDetailsData(action) {
      let updaterowdetails = this.valuedetails;
      if (this.valuedetails.det == '' || this.valuedetails.det == null || this.valuedetails.det == 'null'|| this.valuedetails.det == undefined){
        updaterowdetails = { "sort":[]};
      }
      if (action == 'move') {
        this.premoved = updaterowdetails.rows;
        let arrayData = updaterowdetails.rows;
        arrayData = arrayMoveImmutable(arrayData, this.selectedIndex, 0); 
        updaterowdetails.rows = arrayData;
      }
      else if (action == 'delete') {
        updaterowdetails.rows.splice(this.selectedIndex, 1);
      }
      else {
        Object.keys(this.curentRowDet).forEach(key => {
          updaterowdetails.rows[this.selectedIndex][key] = this.curentRowDet[key];
        });
      }
      this.valuedetails = updaterowdetails;
      this.updateHash();
      this.$emit('update:modelValue', this.valuedetails);
    },

    initDetailsRow(action){
      if(action == 'add'){
        let updaterow = {};
        this.metadetails.columns.forEach(column => {
          updaterow[column.fieldname] = column.init_value;
          });
        this.curentRowDet = updaterow;
      } 
      else if(action == 'clone'){
        let updaterow = {};
        this.metadetails.columns.forEach(column => {
          if (column.copy_value == 'empty' || updaterow[column.fieldname] ==''){
            updaterow[column.fieldname] = column.init_value;
          }  
          else {updaterow[column.fieldname] = this.curentRowDet[column.fieldname]}
        });
        this.curentRowDet = updaterow;
      }  

    },

    addRowDetails(){
      if (this.modelValue == '' || this.modelValue == null || this.modelValue == 'null'||this.modelValue == undefined) {
        this.valuedetails = {"rows":[{}],"det":{ "sort":[]}};
        let updaterow = this.curentRowDet;
        this.valuedetails.rows = [updaterow];

      }
      else { 
        this.valuedetails = this.modelValue;
        if (this.valuedetails.det == '' || this.valuedetails.det == null || this.valuedetails.det == 'null'|| this.valuedetails.det == undefined){
          this.valuedetails.det = { "sort":[]};
        }
        let updaterow = this.curentRowDet;
        this.valuedetails.rows.push(updaterow);
      }
      this.updateHash();
      this.$emit('update:modelValue', this.valuedetails);
    },

    updateHash(){
      let hashlist=[];
      this.valuedetails.rows.forEach(row => {
          hashlist.push(this.gethash(this.metadetails.columns, row));
        }
      )
      this.valuedetails.det.sort = hashlist;
    },

    gethash (columns, obj){
      let hashobj={};
      for(let c =0; c<columns.length; c++){
        let column=columns[c];
        if(column.fieldname in obj){
          if(column.fieldname!='id'  && obj[column.fieldname] && obj[column.fieldname]!='NULL' && obj[column.fieldname]!='null' && column.visible && column.widget){
            if(column.widget.name=='classify'){
              if(obj[column.fieldname]){
                if(typeof obj[column.fieldname] =='object')
                  hashobj[column.fieldname]=obj[column.fieldname].id;
                else
                  hashobj[column.fieldname]=obj[column.fieldname];
              }
            }
            else if(column.widget.name=='date' && typeof obj[column.fieldname]=='string' && obj[column.fieldname].length>=10){
              hashobj[column.fieldname]=obj[column.fieldname].substr(0,10);
            }
            else if(column.widget.name!='details')
              hashobj[column.fieldname]=obj[column.fieldname];
          }
        } 
      }		
      return this.hashCode(JSON.stringify(hashobj))+'';
    },

    hashCode(str) {
      let hash = 0, i, chr;
      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; 
      }
      return hash;
    },

  },

}

</script>
